module.exports = __webpack_public_path__ + "img/p2_r.b3966341.jpg";